import React from 'react'

function Navbar() {
  return (
    <div className='nav-container'>
      <h1>Crate Digger</h1>
    </div>
  )
}

export default Navbar